export const PATIENT_EVOLUTION = '/u/evolution';
export const TEST_REQUEST = '/u/patient/test-request';
export const PRODUCT_RECOMMENDATION_ROUTINE = '/u/routines';
export const PATIENT_PATHOLOGY_TASK_LIST = '/u/pathologies/tasks';
export const TIP_LIBRARY = '/u/tip-library';

const paths = {
  PATIENT_EVOLUTION,
  TEST_REQUEST,
  PATIENT_PATHOLOGY_TASK_LIST,
  PRODUCT_RECOMMENDATION_ROUTINE,
  TIP_LIBRARY
};

export default paths;
